import Vue from "vue";

import Number from "@/filters/Number";
import Percentage from "@/filters/Percentage";
import Beautify from "@/filters/Beautify";

Vue.filter("number", Number);
Vue.filter("percentage", Percentage);
Vue.filter("beautify", Beautify);
